import apiFetch from '../../apiFetch'

export default function (token, processingAgencyId, serviceDestinationId, serviceDestination) {
  return apiFetch({ endPoint: `ProcessingAgency/${processingAgencyId}/ServiceDestinations/${serviceDestinationId}`, method: 'PUT', body: serviceDestination, token: token })
}
